import type { ConversationId } from "PFCore/services/propilot";
import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "propilot.conversationId";

const getOrCreateConversationId = (): ConversationId => {
  const existing = sessionStorage.getItem(STORAGE_KEY);
  return existing ?? crypto.randomUUID();
};

export const useSessionConversationId = (enabled: boolean) => {
  const [conversationId, setConversationId] = useState<ConversationId>(getOrCreateConversationId);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, conversationId);
  }, [enabled, conversationId]);

  const rotateConversationId = useCallback(() => {
    setConversationId(crypto.randomUUID());
  }, []);

  return { conversationId, rotateConversationId };
};

export const clearSessionConversationId = (): void => {
  sessionStorage.removeItem(STORAGE_KEY);
};
